const getCategoriesRoot = ({ el, available = false, request = false, hot = false }) => {
  if (!el.packages) return el
  let p
  if (available) p = el.packages.find(pack => pack.categories.find(c => c.hotelIsAvailable))
  if (request) p = el.packages.find(pack => pack.categories.find(c => !c.hotelIsBlackedOut))
  if (request) p = el.packages.find(pack => pack.isHotDeal || (pack.categories.find(c => c.isSpecial) !== undefined))
  return p || el.packages[0]
}

const sortByPrice = (a, b) => {
  let aPrice = { price: Number.MAX_SAFE_INTEGER, tax: 0 }
  let bPrice = { price: Number.MAX_SAFE_INTEGER, tax: 0 }
  
  const aRoot = getCategoriesRoot({ el: a })
  const bRoot = getCategoriesRoot({ el: b })

  if (aRoot && aRoot.categories && aRoot.categories.length && aRoot.categories[0].meals && aRoot.categories[0].meals.length) {
    aPrice = aRoot.categories[0].meals[0]
  }
  if (bRoot && bRoot.categories && bRoot.categories.length && bRoot.categories[0].meals && bRoot.categories[0].meals.length) {
    bPrice = bRoot.categories[0].meals[0]
  }

  return aPrice.price + aPrice.tax - bPrice.price - bPrice.tax
}

const sortByAva = (a, b) => {
  const aIsAvailable = getCategoriesRoot({ el: a, available: true }).categories.find(el => el.hotelIsAvailable)
  const bIsAvailable = getCategoriesRoot({ el: b, available: true }).categories.find(el => el.hotelIsAvailable)
  const aIsRequest = getCategoriesRoot({ el: a, request: true }).categories.find(el => !el.hotelIsBlackedOut)
  const bIsRequest = getCategoriesRoot({ el: b, request: true }).categories.find(el => !el.hotelIsBlackedOut)
  if (aIsAvailable !== undefined && bIsAvailable !== undefined) return sortByHotDeal(a, b)
  if (aIsRequest === undefined && bIsRequest === undefined) return sortByHotDeal(a, b)
  if (aIsAvailable) return -1
  if (bIsAvailable) return 1
  if (aIsRequest) return -1
  if (bIsRequest) return 1
  return sortByHotDeal(a, b)
}

const sortByHotDeal = (a, b) => {
  const aRoot = getCategoriesRoot({ el: a, hot: true })
  const bRoot = getCategoriesRoot({ el: b, hot: true })
  const aIsHot = a.isHotDeal || aRoot.isHotDeal || (aRoot.categories.find(el => el.isHotDeal) !== undefined)
  const bIsHot = b.isHotDeal || bRoot.isHotDeal || (bRoot.categories.find(el => el.isHotDeal) !== undefined)
  if (aIsHot && bIsHot) return sortByPrice(a, b)
  if (aIsHot) return -1
  if (bIsHot) return 1
  return sortByPrice(a, b)
}

const sortByPriceDesc = (a, b) => {
  return sortByPrice(b, a)
}

const sortByStarRating = (a, b) => {
  return a.stars === b.stars ? sortByPrice(a, b) : a.stars - b.stars
}

const sortByStarRatingDesc = (a, b) => {
  return sortByStarRating(b, a)
}

const sortByHotelName = (a, b) => {
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
  return sortByPrice(a, b)
}

const sortByHotelNameDesc = (a, b) => {
  return sortByHotelName(b, a)
}

export {
  sortByAva,
  sortByHotDeal,
  sortByHotelName,
  sortByHotelNameDesc,
  sortByPrice,
  sortByPriceDesc,
  sortByStarRating,
  sortByStarRatingDesc
}
